
import {
  Component,
  HostListener, Input, OnInit
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SharedModule } from '../../../sharedmodule/shared.module';
import { FooterListingService } from '../../../../sdk/services/custom/footer-listing.service';
import { AuthService } from './../../../../sdk/services/core/auth.service';
import { PreviousRouteService } from './../../../../sdk/services/custom/previous-route.service';
import { NavbarRerenderService } from './../../../../sdk/services/helper/navbar-rerender.service';
import { url } from './../../../cloudFrontUrl';
import { ListingApi } from 'src/sdk/services/custom/listing.service';

declare var google: any;

@Component({
  standalone: true,
  selector: 'app-footer',
  imports: [
    RouterModule,
    NzGridModule,
    NzMenuModule,
    NzIconModule,
    SharedModule
],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  routerUrlLink = '/';
  privacyPolicyLink = '/terms/privacy-policy';
  tosLink = '/terms/tos';
  supportEmailVisible = false;
  comingSoonVisible = false;
  hideFooterTop: boolean = false;
  hideFooterForConfirmation = false;
  @Input() hideFooterForFlatFee: boolean = false;
  isLogin = false;
  showFooter = false;
  lat;
  long;
  real_estate_array = this.footerListService.FooterListing_real_estate;
  rental_array = this.footerListService.FooterListing_rentals;
  mortage_rate_array = this.footerListService.FooterListing_mortage_rate;
  assetUrl: string;
  isMobile: boolean = false;
  isFlatFeeMenu : boolean = false;
  isForSaleMenu : boolean = false;
  // browse_homes_array=this.footerListService.FooterListing_browse_homes;

  // @ViewChild('SendSupportEmailHost', { read: ViewContainerRef, static: true }) public SendSupportEmailHost: ViewContainerRef;
  // SendSupportEmailContainer;

  constructor(
    private footerListService: FooterListingService,
    private pr: PreviousRouteService,
    private authService: AuthService,
    private router: Router,
    private navbarRerenderService: NavbarRerenderService,
    private message: NzMessageService,
    private listingApi: ListingApi,
    // private resolver: ComponentFactoryResolver,
  ) {
    // console.log('FooterComponent constructor');

    router.events.subscribe((val) => {
      const route = this.router.url;


      if (route === '/sell') {
        // console.log('what is this')
        this.hideFooterTop = true;
      } else {
        this.hideFooterTop = false;
      }
      if (route === '/Thank-you' || route === '/meeting-booked' ) {
        this.hideFooterTop = true;
      } else {
        this.hideFooterTop = false;
      }
      if (route === '/' || route == '/home') {
        this.hideFooterTop = true;
        this.hideFooterForConfirmation = false;

      }
      // console.log('hideFooterTop', this.hideFooterTop)
      // console.log('hideFooterForConfirmation', this.hideFooterForConfirmation);

    });



    const route = this.router.url;


    if (route === '/sell') {
      this.hideFooterTop = true;
    } else {
      this.hideFooterTop = false;
    }
    if (route === '/Thank-you' || route === '/meeting-booked') {
      this.hideFooterTop = true;
    } else {
      this.hideFooterTop = false;
    }
    this.navbarRerenderService.currentMessage.subscribe((message) => {
      if (message === 'refreshhomedata') {
        this.checkLogin();
      }
    })
    this.assetUrl = url
  }

  ngOnInit(): void {
    // console.log('ngOnInit FooterComponent')

    this.checkLogin();
    if (this.router.url == '' || this.router.url == '/') {
      this.hideFooterTop = true;
      this.checkMobile();
    }
  }
  checkLogin() {
    try {
      const access_token = this.authService.getAccessTokenId();
      if (access_token) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    } catch (error) {
      console.log('error', error);
      this.isLogin = false;
    }
  }
  openSupportEmailPopup() {
    this.supportEmailVisible = true;
  }
  closeEmailSupportPopup() {
    this.supportEmailVisible = false;
    // this.SendSupportEmailHost?.clear();
  }

  comingSoonPop() {
    this.comingSoonVisible = true;
  }
  closeComingSoonPop() {
    this.comingSoonVisible = false;
  }
  async onNavigate(item) {
    debugger;
    // let name = item.name;
    // name = name.replace(' Real Estate', '');
    // name = name.replace(' For Sale by Owner', '');
    // name = name.replace(' Flat Free Broker', '');
    // // name = name.replace(' Homes for Sale', '');
    // name = `${name} louisiana`;
    // this.getLatitudeLongitude(name);
    if (item.name.split(' ').length == 3) {
      // console.log('itemclicked',item)
      // console.log('Length',item.name.split(' ').length,item.name.split(' '))
      let url = 'LA/' + item.name.split(' ')[0]
      // console.log(url)
      this.router.navigate([url])
    } else {
      let url = 'LA/' + item.name.split(' ')[0]
      url = url + '-' + item.name.split(' ')[1]
      // console.log(url)
      this.router.navigate([url])
    }
  }
  onPopluarNavigate(item) {
    if (item.name.split(' ').length == 4) {
      // console.log('itemclicked',item)
      // console.log('Length', item.name.split(' ').length, item.name.split(' '))
      let url = 'LA/' + item.name.split(' ')[0]
      // console.log(url)
      this.router.navigate([url])
    } else {
      let url = 'LA/' + item.name.split(' ')[0]
      url = url + '-' + item.name.split(' ')[1]
      // console.log(url)
      this.router.navigate([url])
    }
  }
  onHomesNavigate(item) {
    // console.log('on state click',item)
    let url = 'browse/homes/' + item.abbrev
    // console.log(url)
    this.router.navigate([url])
  }
  async getLatitudeLongitude(city) {
    let geocoder = new google.maps.Geocoder();
    if (geocoder) {
      geocoder.geocode(
        {
          address: city,
        },
        (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            const res = results[0];
            let location = {
              lat: res.geometry.location.lat(),
              lng: res.geometry.location.lng(),
            };
            this.authService.saveLatLngToLocalStorage(JSON.stringify(location));
            const url = '/listings';
            this.router.navigateByUrl(url);
          }
        }
      );
    }
  }
  // loadSendSupportEmail(){
  //   import('./../../../../app/sharedmodule/components/send-support-email/send-support-email.component').then(({ SendSupportEmailComponent }) => {
  //     const factory = this.resolver.resolveComponentFactory(SendSupportEmailComponent);
  //      this.SendSupportEmailHost?.clear();
  //     this.SendSupportEmailContainer = this.SendSupportEmailHost.createComponent(factory);
  //     this.openSupportEmailPopup();
  //     this.SendSupportEmailContainer.instance.close.subscribe((data) => {
  //       this.closeEmailSupportPopup();
  //     });
  //   });  
  // }


  routeGetStarted() {
    if (this.isLogin) {
      this.router.navigateByUrl('/listing');
    } else {
      this.pr.goto = '/listing';
      this.router.navigateByUrl('/signup');
    }
  }

  async routeGetStartedPayment() {
    if (this.isLogin) {
      this.router.navigateByUrl('/listing-payment');
    } else {
      this.pr.goto = '/listing-payment';
      this.router.navigateByUrl('/signup');
    }
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  onEvent(event) {
    this.checkMobile();
  }

  checkMobile() {
    const windowWidth =
      window.screen.width < window.outerWidth
        ? window.screen.width
        : window.outerWidth;
    if (windowWidth < 480) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
  navigateToFAQs() {
    // console.log('no here')
    let url = 'https://falaya.com/faqs'
    window.location.href=url
  }

  downloadBrokerageServicesDoc(){
     this.listingApi
     .viewBrokerageServicesDoc()
     .subscribe(
       (data) => {
         let signedUrl = data.uri;
         window.open(signedUrl, '_blank');
       },
       (error) => {
        
       }
     );
     
  }

  toggleMenu(menuType) {
    this.isFlatFeeMenu = menuType === 'flatFee' ? !this.isFlatFeeMenu : false;
    this.isForSaleMenu = menuType === 'forSale' ? !this.isForSaleMenu : false;
  }
}
